import { createContext } from 'react';

const UserContext = createContext();

export const UserProfileContext = createContext();

export const UserFinanceContext = createContext();

export const StoreContext = createContext();
export const PusherContext = createContext();

export const WarehouseContext = createContext();

export default UserContext;
